import swal from "sweetalert";
import i18next from "i18next";

export const alert = (title, data, type) => {
  return swal(title, data, type);
};

export const warning = () => {
  return swal({
    title: i18next.t("are_you_sure"),
    icon: "warning",
    dangerMode: true,
    buttons: true,
  });
};

export const permissionError = () => {
  return swal({
    title: i18next.t("opps_you_are_block_by_admin"),
    icon: "error",
  });
};
